/**
 * Field Type Groups Constants
 * Organizes field types into logical groups for better organization and filtering
 */

/**
 * Layout & Content Fields (non-interactive)
 */
export const LAYOUT_CONTENT_FIELDS = ['heading', 'paragraph', 'divider'];

/**
 * Layout Container Fields (for grouping/organizing fields)
 */
export const LAYOUT_CONTAINER_FIELDS = ['tabs'];

/**
 * Text Input Fields
 */
export const TEXT_INPUT_FIELDS = ['text', 'email', 'number', 'password', 'url', 'tel', 'search'];

/**
 * Financial Fields
 */
export const FINANCIAL_FIELDS = ['currency', 'price'];

/**
 * Textarea Fields
 */
export const TEXTAREA_FIELDS = ['textarea'];

/**
 * Selection Fields (require options)
 */
export const SELECTION_FIELDS = ['select', 'radio', 'checkbox', 'tags'];

/**
 * Date/Time Fields
 */
export const DATE_TIME_FIELDS = ['date', 'time', 'datetime-local', 'month', 'week'];

/**
 * File Upload Fields
 */
export const FILE_FIELDS = ['file', 'attachment', 'image'];

/**
 * Advanced/Complex Fields
 */
export const ADVANCED_FIELDS = ['repeater', 'range',
// 'color',
'rating', 'signature', 'switch'];

/**
 * All Input Fields (fields that accept user input)
 */
export const INPUT_FIELDS = [...TEXT_INPUT_FIELDS, ...FINANCIAL_FIELDS, ...TEXTAREA_FIELDS, ...SELECTION_FIELDS, ...DATE_TIME_FIELDS, ...FILE_FIELDS, ...ADVANCED_FIELDS];

/**
 * All Field Types
 */
export const ALL_FIELD_TYPES = [...INPUT_FIELDS, ...LAYOUT_CONTENT_FIELDS, ...LAYOUT_CONTAINER_FIELDS];

/**
 * Check if a field type is a layout/content field
 */
export const isLayoutContentField = fieldType => {
  return LAYOUT_CONTENT_FIELDS.includes(fieldType);
};

/**
 * Check if a field type requires options
 */
export const requiresOptions = fieldType => {
  return SELECTION_FIELDS.includes(fieldType);
};

/**
 * Check if a field type accepts user input
 */
export const isInputField = fieldType => {
  return INPUT_FIELDS.includes(fieldType);
};

/**
 * Check if a field type is a container field (can contain other fields)
 */
export const isContainerField = fieldType => {
  return LAYOUT_CONTAINER_FIELDS.includes(fieldType);
};

/**
 * Check if a field type should not have conditions or validations
 */
export const shouldExcludeConditionsAndValidations = fieldType => {
  return isLayoutContentField(fieldType) || isContainerField(fieldType);
};